import { render } from "./CompanyRoundedButton.vue?vue&type=template&id=439028ed"
import script from "./CompanyRoundedButton.vue?vue&type=script&lang=js"
export * from "./CompanyRoundedButton.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__